import { Box, Center } from '@chakra-ui/react';
import { AccountLaunchpad } from '@src/components/sco/Account/AccountLaunchpad';
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext';
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { AccountPage } from '@src/layouts/AccountPageLayout';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default AccountPage(function () {
  const accountContext = useAccountContext();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('account.landing');
  });
  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([{
      title: 'Account',
      href: '/account'
    }]);
  }, []);
  return <AccountMainPanel>
      <Center minHeight={'80vh'} padding={['1em', '2em']}>
        <Box maxWidth={'container.lg'} width={'full'}>
          <SSRGate disableSSR={true}>
            <AccountLaunchpad />
          </SSRGate>
        </Box>
      </Center>
    </AccountMainPanel>;
});